module.exports = require('../lib/linkify/plugins/mention').default;
